// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { ChatPage } from './';

export default {
  path: 'messages',
  childRoutes: [
    { path: 'default/', component: ChatPage },
    { path: 'default/:chatId', component: ChatPage },
  ],
};
